import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';
import { Button } from 'components/Button';
import Icon from 'components/Icon';
import QuickView, { useQuickView } from 'components/quickView';
import dynamic from 'helpers/dynamic';

const AdditionalInfo = dynamic(() => import('./AdditionalInfoDetails'), { ssr: false });

const StyledButton = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: 0;
`;

const StyledQuickView = styled(QuickView)`
    max-width: 520px;
`;

type IAdditionalInfoButton = HTMLAttributes<HTMLButtonElement>;

export default function AdditionalInfoButton(props: IAdditionalInfoButton) {
    const { className } = props;
    const { toggle } = useQuickView('campaignAdditionalInfo');

    function showAdditionalInfo() {
        toggle(true);
    }
    return (
        <>
            <StyledButton className={className} onClick={showAdditionalInfo}>
                <Icon type="Information" size={16} />
            </StyledButton>
            <StyledQuickView quickViewId="campaignAdditionalInfo" position="right">
                <AdditionalInfo />
            </StyledQuickView>
        </>
    );
}
